import { render, staticRenderFns } from "./MultiBoolSelect.vue?vue&type=template&id=1b24d00f&scoped=true"
import script from "./MultiBoolSelect.vue?vue&type=script&lang=ts"
export * from "./MultiBoolSelect.vue?vue&type=script&lang=ts"
import style0 from "./MultiBoolSelect.vue?vue&type=style&index=0&id=1b24d00f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b24d00f",
  null
  
)

export default component.exports